import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';

//Notification
import { openLink } from 'Core/data/Helpers';

//Endpoints
import { endpoints } from 'Core/defaultValues';

//Helpers
import { LogManager } from 'Core/logManager';

//Actions
import {
    authGetAuthenticationDetailsRequest,
    searchCountNotificationsRequest,
    dashboardPanelSearchRequest,
    setCreateNotificationId,
    searchEntityRequest,
    generalExport,
    completePendingExport,
    refreshToken,
    clearRedux,
    logoutRequest
} from 'Redux/actions';

const Catalog = () => {
    const { messages } = useIntl();
    let client;

    const dispatch = useDispatch();

    //Redux States
    const { refreshTokenResult, systemPreference } = useSelector(state => state.securityRedux);
    const { logoutResult } = useSelector(state => state.loginRedux);

    const navigate = useNavigate();

    useEffect(() => {
        if (refreshTokenResult) {
            dispatch(authGetAuthenticationDetailsRequest());
            dispatch(clearRedux("AUTH", { refreshTokenResult: false }));
            if (client) {
                LogManager("refresh socket open")
                client.open()
            }
            else {
                LogManager("refresh socket create")
                createSocketConnection()
            }
        }
    }, [refreshTokenResult]);

    //Effect to create socket connection
    useEffect(() => {
        LogManager('init socket');
        createSocketConnection();

        return () => {
            client.close();
        };
    }, []);

    useEffect(() => {
        document.addEventListener("refreshToken", res => {
            dispatch(clearRedux("AUTH", { refreshTokenResult: true }));
        })
        return () => {
            document.removeEventListener("refreshToken", null);
        };
    }, []);

    useEffect(() => {
        if (logoutResult) {
            logout();
            dispatch(clearRedux("LOGIN", { logoutResult: null }));
        }
    }, [logoutResult]);

    //Logout function

    const logout = useCallback(() => {
        navigate(`/login`);
        dispatch(clearRedux("GENERAL"));
        localStorage.clear();
    });

    const createSocketConnection = () => {
        const token = localStorage.getItem('IdToken');
        let WSSURL = systemPreference && systemPreference[process.env.STACK]?.wss || endpoints.WSS_READINGS;

        const wss = WSSURL + '?token=' + token + "&appId=pm-web";
        client = new WebSocket(wss);

        client.onmessage = ({ data }) => {
            let messageJSON = JSON.parse(data);
            LogManager('messageJSON', messageJSON);

            if (Array.isArray(messageJSON)) {
                messageJSON.forEach(element => {
                    processPushNotification(element?.payload)
                });
            } else processPushNotification(messageJSON?.payload)
        }

        client.onclose = (e) => {
            LogManager('ws closed', e.code);
            LogManager('Refresh Token Socket');
            dispatch(refreshToken());
        }
    }

    const processPushNotification = (payload) => {
        if (payload?.type) {
            switch (payload.type) {
                case "OPEN_URL":
                    if (payload.sessionId === sessionStorage.getItem("sessionId")) {
                        openLink(payload.data.url);
                        dispatch(completePendingExport({ url: payload.data.url }));
                        dispatch(generalExport(true));
                        dispatch(searchCountNotificationsRequest());
                    }
                    break;
                case "REFRESH_TOKEN":
                    dispatch(refreshToken());
                    dispatch(clearRedux("GENERAL", { dealers: [] }));

                    break;
                case "REFRESH_DEVICE_MODELS":
                    dispatch(searchEntityRequest({ key: "deviceModels" }));

                    break;
                case "LOGOUT":
                    console.log("Logout by push notification")
                    dispatch(logoutRequest());
                    //logout();
                    break;
                case "REFRESH_DASHBOARD":
                    dispatch(dashboardPanelSearchRequest())
                    break;
                case "VIDFLEET_FIRMWARE_UPDATED":
                    dispatch(clearRedux("GENERAL", { firmwares: [] }));
                    dispatch(searchEntityRequest({ key: "firmwares" }));
                    break;
                case "REFRESH_DEALERS":
                    dispatch(clearRedux("GENERAL", { dealers: [] }));
                    dispatch(searchEntityRequest({ key: "dealers" }));
                    break;
                case "REFRESH_MANUFACTURERS":
                    dispatch(clearRedux("GENERAL", { manufacturers: [] }));
                    dispatch(searchEntityRequest({ key: "manufacturers" }));
                    break;
                case "REFRESH_EVENTS":
                    dispatch(clearRedux("GENERAL", { events: [] }));
                    dispatch(searchEntityRequest({ key: "events" }));
                    break;
                case "CREATE_NOTIFICATION":
                    if (payload.data.transactionId) {
                        dispatch(setCreateNotificationId(payload.data.transactionId))
                    }
                    break;
                default:
                    //always that a push notification comes, make a call for refresh the pending notifications counter
                    break;
            }
        }
    }

    return <></>

}

export default Catalog;